module.exports = __webpack_public_path__ + "static/media/compare-progress.d3609d43.svg";